module.exports = __webpack_public_path__ + "img/henkel-cedis-gdl.c141fe77.jpg";